import { render, staticRenderFns } from "./GuitarTab.vue?vue&type=template&id=56023490&"
import script from "./GuitarTab.vue?vue&type=script&lang=js&"
export * from "./GuitarTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports